/* Light / dark mode toggle with localStorage persistence */
(function () {
    const STORAGE_KEY = 'behzaaad-theme';
    const root = document.documentElement;
    const toggles = document.querySelectorAll('[data-theme-toggle]');
    if (!toggles.length) return;

    function syncToggleButtons(theme) {
        const isDark = theme === 'dark';
        toggles.forEach(function (btn) {
            btn.setAttribute('aria-pressed', isDark ? 'true' : 'false');
            btn.setAttribute('aria-label', isDark ? 'Switch to light mode' : 'Switch to dark mode');
            btn.classList.toggle('is-dark', isDark);
            btn.classList.toggle('is-light', !isDark);
        });
    }

    function applyTheme(theme) {
        root.setAttribute('data-theme', theme);
        localStorage.setItem(STORAGE_KEY, theme);
        root.classList.remove('has-light-text', 'has-dark-text');
        root.classList.add(theme === 'light' ? 'has-dark-text' : 'has-light-text');
        syncToggleButtons(theme);
    }

    toggles.forEach(function (btn) {
        btn.addEventListener('click', function () {
            const next = root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
            applyTheme(next);
        });
    });

    /* Theme already set by inline head script — only sync button UI */
    syncToggleButtons(root.getAttribute('data-theme') || 'dark');
})();
